import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

  (function ($, Drupal, cookies) {
    'use strict';

    Drupal.behaviors.helloWorld = {
      attach: function attach(context) {

        var getUrlParameter = function getUrlParameter(sParam) {
          var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

          for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
          }
        };
        jQuery(document).ready(function(){
          jQuery('.search-icon-re').unbind().bind('click', function () {
            console.log("in");
            jQuery('.search-icon-re').toggleClass('active');
            jQuery('.searchblock').toggleClass('active');
            jQuery('.product-search-form').focus();

          });

          if(!cookies.get('subscribe') && getUrlParameter('nl')!=1){
            setTimeout(function(){
              jQuery('#subscribepopup').addClass('active');
            },7000);
          }

          jQuery('#subscribepopup a').click(function(){
            cookies.set('subscribe', 'yes', { path: '/' });
          });

          jQuery('#subscribepopup .close').click(function(){
            jQuery('#subscribepopup').removeClass('active');
            cookies.set('subscribe', 'yes', { path: '/' });
          });

        })

        jQuery('.compartir').click(function(){
          jQuery('.share').slideDown();
        })

        if(jQuery('.center').length){
          jQuery('.center').not('.slick-initialized').slick({
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 4,
            speed: 300,
            autoplay: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 1600,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '80px',
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1300,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '60px',
                  slidesToShow: 2
                }
              }, ,
              {
                breakpoint: 1250,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '60px',
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '40px',
                  slidesToShow: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: false,
                  centerMode: true,
                  centerPadding: '60px',
                  slidesToShow: 1
                }
              }
            ]
          });
        }
        if(jQuery('.one-time').length){
          jQuery('.one-time').not('.slick-initialized').slick({
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            arrows:true,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<button class="slick-prev-ods" aria-label="Prev" type="button" ><span>←</span></button>',
            nextArrow: '<button class="slick-next-ods" aria-label="Next" type="button" ><span>←</span></button>',

          });
        }
        if(jQuery('.fullscreen').length){
          var altCat = 75;
          var slideHeight = jQuery(window).innerHeight() - altCat;
          jQuery(".fullscreen").css('height',slideHeight);


          jQuery('.fullscreen').not('.slick-initialized').slick({
            draggable: true,
            autoplay: true,
            autoplaySpeed: 4500,
            arrows: false,
            dots: true,
            fade: false,
            speed: 500,
            infinite: true,
            cssEase: 'ease-in-out',
            // touchThreshold: 100
          })


        }
        jQuery('.article--teaser').each( function(i){

          var top_of_object = jQuery(this).offset().top +20 ;
          var bottom_of_window = jQuery(window).scrollTop() + jQuery(window).height();

          /* Adjust the "200" to either have a delay or that the content starts fading a bit before you reach it  */
        //  bottom_of_window = bottom_of_window;
          console.log(bottom_of_window);
          if( bottom_of_window > top_of_object ){

            // jQuery(this).animate({'opacity':'1', 'transform','translateY(0)'},300);
            jQuery(this).addClass('loaded');
          }
        });
        var docHeight = jQuery(document).height();

        jQuery(window).scroll( function(){
          var winHeight = jQuery(window).height();
          var winWidth = jQuery(window).width();
          var winScroll = jQuery(window).scrollTop();

          jQuery('.llista_home').each( function(i){
            if(winScroll > 250){
              jQuery('.navbar-dark').addClass('home');
            }
            else{
              jQuery('.navbar-dark').removeClass('home');


            }

            if(winScroll > jQuery(this).offset().top  ) {
              jQuery('.navbar-dark').addClass('sticky');
              jQuery('.branding-bar').addClass('visible');
              jQuery('.navbar-toggler').addClass('baix');

            }
            else{
              jQuery('.navbar-dark').removeClass('sticky');
              jQuery('.branding-bar').removeClass('visible');
              jQuery('.navbar-toggler').removeClass('baix');

            }
          });
          jQuery('.article--teaser').each( function(i){
            var bottom_of_window = winHeight + winScroll;
            bottom_of_window = bottom_of_window -100;
            var top_of_object = jQuery(this).offset().top +20 ;

            /* Adjust the "200" to either have a delay or that the content starts fading a bit before you reach it  */
            if( bottom_of_window > top_of_object ){

              // jQuery(this).animate({'opacity':'1', 'transform','translateY(0)'},300);
              jQuery(this).addClass('loaded');
            }
          });
          if(jQuery('#readbar').length){
            //jQuery('#readbar').height(winHeight * (winScroll*docHeight/100));
            var newWidth =Math.round(winScroll*100/docHeight);
            jQuery('#readbar').css('width',newWidth + "%");
            jQuery('#readbar_container').css('top',jQuery('.navbar-dark').outerHeight());
          }



        });

      }
    };

  })(jQuery, Drupal, window.Cookies);

})();
